import { GridCell } from '@progress/kendo-react-grid';
import * as _ from 'lodash';
import * as React from 'react';
import { Link } from 'react-router-dom';

import { Formatters } from '../../formatters';
import { GridUtilities } from '../gridutilities';

export class CellWithTruncate extends GridCell {
    public render() {
        return (
            <td>
                <div className="truncate">{_.get(this.props, `dataItem['${_.get(this.props, 'field')}']`)}</div>
            </td>
        );
    }
}

export class CellRTLWithTruncate extends GridCell {
    public render() {
        return (
            <td>
                <div className="truncate reminder-bids-cell-content-rtl">{_.get(this.props, `dataItem['${_.get(this.props, 'field')}']`)}</div>
            </td>
        );
    }
}

export class CellWithLink extends GridCell {
    public constructor(props: any) {
        super(props);
    }

    public render() {
        const { dataItem, field, ...rest } = this.props;

        const obj = dataItem[field as string];
        const linkText = Formatters.getStr(obj, 'text');
        const linkHref = Formatters.getStr(obj, 'href');
        const linkTitle = Formatters.getStr(obj, 'title');

        const className = `k-grid-column-row-link ${GridUtilities.KendoGridClassTextLeft}`;

        return (
            <td className={className}>
                <Link to={linkHref} title={linkTitle}>{linkText}</Link>
            </td>);
    }
}

export class CellWithSelectedCheckbox extends GridCell {
    public constructor(props: any) {
        super(props);
    }

    public handleChange(e: any) {
        const { dataItem, field, onChange } = this.props;

        const value = !Formatters.getBool(dataItem, field as string, false);

        if (onChange) {
            onChange({
                dataItem: dataItem,
                field: field,
                syntheticEvent: e.syntheticEvent,
                value: value
            });
        }
    }

    public render() {
        const { dataItem, field } = this.props;

        const value = Formatters.getBool(dataItem, field as string);

        const className = `k-grid-column-row-selected-checkbox k-grid-checkbox-input ${GridUtilities.KendoGridClassTextCenter}`;

        const tdInput = (
            <input
                    type="checkbox"
                    checked={value}
                    onChange={(e) => { if (this.handleChange) { this.handleChange(e); }}}
                />
        );

        return (<td className={className}>{tdInput}</td>);
    }
}



// WEBPACK FOOTER //
// ./src/common/grid/grid-cell-components/gridcell-renderers.tsx